import React from 'react';
import PropTypes from 'prop-types';
import {
  List,
  ListCheckbox as RTListCheckbox,
  ListSubHeader,
} from 'react-toolbox/lib/list';
import glamorous from 'glamorous';

const ListCheckbox = glamorous(RTListCheckbox)({
  '& span': {
    whiteSpace: 'normal !important',
  },
  '& label div': {
    marginRight: '1rem !important',
  },
});

const CheckBoxList = ({ title, list, onChange, isChecked }) => (
  <List>
    <ListSubHeader caption={title} style={{ fontWeight: 'bold' }} />
    {list.map(state => (
      <ListCheckbox
        key={state.id}
        caption={state.name}
        checked={isChecked(state)}
        onChange={onChange(state)}
      />
    ))}
  </List>
);

CheckBoxList.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  filters: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  isChecked: PropTypes.func.isRequired,
};

export default CheckBoxList;



// WEBPACK FOOTER //
// ./src/App/events/components/CheckboxList.js